import About from 'components/services/commons/About'
import Assignment from 'components/services/commons/Assignment'
import Whyi3 from 'components/services/commons/Whyi3'
import styles from 'components/services/hip/Template.module.scss'
import Process from 'components/services/commons/Process'
import ServiceMainTitle from 'components/services/commons/ServiceMainTitle'
import { serviceMainTitle } from './TitleGroup'
import CaseStudyLarge from '../commons/CaseStudyLarge'
import { CaseStudySliderItem } from '../commons/CaseStudyLarge/PCCaseStudy/PCCaseStudyList'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

const Hip: React.FC = () => {
  const paths = [
    { name: 'TOP', url: '/' },
    { name: 'Services', url: '#' },
    { name: '組織開発・人材育成', url: '#' },
  ]

  const aboutList = [
    {
      text: '企業の次世代リーダークラスを対象として、イノベーション創出に必要なフレームワークを活用した超実践型ワークショップを提供します。',
    },
    {
      text: '組織全体を横断した網羅的かつ本質的な課題抽出を行い、独自のフレームワークを利用して顧客ニーズを特定します。',
    },
    {
      text: 'そして、得られたアイデアやソリューション案を評価し、より具体的なプロジェクト計画から実行まで支援します。',
    },
  ]

  const assignmentList = [
    {
      title: 'DX推進の適任者がいない',
      text: '自社の本質的な課題と向き合う当事者意識が醸成され、DX推進の適任者を見つけることができます。',
    },
    {
      title: '全体最適なDX化が進まない',
      text: '顧客が求める本質的なニーズを再認識でき、具体的な新規事業アイデアや課題解決ソリューションを策定できます。',
    },
  ]

  const reasonList = [
    {
      icon: '/images/icons/icon_double.svg',
      title: '組織開発とサービスバリューの探求',
      text: 'JOB理論フレームワークを社内の組織開発と、顧客の本質JOB（成し遂げたいこと）探究の両目的で活用ができる。',
    },
    {
      icon: '/images/icons/icon_introduction.svg',
      title: '本質的なアイデアの創出',
      text: '自社のコア・コンピタンスや顧客JOBを踏まえた本質的かつ網羅的なアイデア、ソリューション案を導出できる。',
    },
    {
      icon: '/images/icons/icon_customize.svg',
      title: '顧客ごとにカスタマイズしたメニュー',
      text: 'クライアント企業の課題に応じたメニュー選択ができ、開催日時も自由度高くカスタマイズできる。',
    },
    {
      icon: '/images/icons/icon_onestop.svg',
      title: 'プロジェクトの立ち上げフェーズも支援',
      text: 'アイデア、ソリューション案をベースとした自社プロジェクトの立ち上げから推進まで一気通貫で支援。',
    },
  ]

  const processList = [
    {
      title: 'ワークショップの準備',
      term: '1ヶ月',
      text: '対象となる事業部門と役割を提供する顧客を設定し、顧客の本質的かつ高解像度なJOB（成し遂げたいこと）を抽出するための緻密なプログラムを策定します。\n（課題に応じて、社内向け・社外向けいずれかを選択した上で進める）',
      deliverables: [{ link: '#', name: 'ワークショップサービスの提供' }],
    },
    {
      title: 'ワークショップの開催',
      term: '1ヶ月',
      text: 'クライアント社内のリーダー候補20~30名を対象に、プログラムに沿ってワークショップを実施します。',
      deliverables: [
        { link: '#', name: 'アイデア、ソリューション案' },
        { link: '#', name: '自社のコア・コンピタンス、顧客JOBを踏まえた一連のアウトプット' },
      ],
    },
    {
      title: 'アフターワークショップの実施',
      term: '1~2ヶ月',
      text: 'ワークショップ時に生成されたアイデア、ソリューション案をベースに、プロジェクトの立ち上げから推進までを支援します。',
      deliverables: [{ link: '#', name: 'DXアセスメント結果シート（自社のDX推進度合いを定量分析したもの）' }],
    },
  ]

  const caseStudyList: CaseStudySliderItem[] = [
    {
      src: '/images/img/service/caseStudy/docomo.png',
      logo: '/images/logo/logo_dcm_c.png',
      title: '部門横断でのサービス検討',
      problem:
        '部門横断するプロジェクトで参加者の課題感ならびに温度が一様ではなかった。その為、改めて関係者のベクトルを合わせて、提供するサービス価値向上施策を検討したい。',
      caseName: 'プロジェクトファシリテーション',
      client: 'NTTドコモ',
      term: '2ヶ月',
      overview:
        '日本企業は研究開発部門においては非常に魅力的な技術検証を行っています。その一方で、その社内技術をどういったサービスにして、どういった顧客に提供すべきかといったと商用化のレベルで頓挫していることが少なくありません。NTTドコモでもAIを使った画像認識分野で高い技術力を有していましたが、これを使った実際のサービス開発においてどういったサービスにするかが曖昧なままでいました。そのためこのプロジェクトでDesignSprintを応用した当社の独自フレームワークを用いて顧客の定義、競合との差別化、リーンキャンバスを用いた価値検討、ユーザーヒアリングからプロトタイピングと3ヶ月、アイディエーションと検証、プロトタイピングを3回繰り返すことによってサービスの解像度を上げています。このプロジェクトを通して得られる成果物は、リーンキャンバス 、構造化シナリオ、プロダクト化された際のUIデザイン、想定顧客からのフィードバックとなります。',
    },
    {
      src: '/images/img/service/caseStudy/kaneka.png',
      logo: '/images/logo/logo_knk_c.png',
      title: 'DX推進のための組織・チーム開発',
      problem:
        '社内にデジタルを使ったコンシューマー向けの知見がなかった。そのためDXのデジタライゼーションが何かから社内にインプリする必要があった。',
      caseName: '組織・チーム開発',
      client: '株式会社カネカ',
      term: '3ヶ月',
      overview:
        'DXにおけるデジタライゼーションによる新規サービスの創出を行いたい企業は多いと思います。化学メーカーである同社もデザイン思考を取り入れてのDXを社内でも議論はしていたが、実際のプロジェクト化においては二の足を踏んでいましたた。そのためデジタルを活用をしたサービス創造のためのアイディエーションを行う前に、関連部署のキーパーソンを中心にイノベーション創出ためのワークショッププログラムを実施しました。プログラム内容は、マシュマロタワーといった体を使ったアイスブレークから、ビジネスモデル研究といった課題でデジタルサービスをUXの視点、お金の流れといった観点から課題ワークとグループディスカッション構成からなっています。参加メンバーは30名弱であったため一つのチームを5名程度にし6チームでITサービスのビジネスモデル検討からアイデアコンテストを実施しています。',
    },
    {
      src: '/images/img/service/caseStudy/hitachi.png',
      logo: '/images/logo/logo_ntt-htc.png',
      title: '未来思考によるビジネス機会の検討',
      problem:
        '事業提携にともなう協業サービスの検討にあたってデザイン思考を取り入れたアイディエーションを行いたいと思っていた。これにあたって外部からの知見を取り入れたいと思っていた。',
      caseName: '組織・チーム開発',
      client: 'NTTコミュニケーションズ・日立製作所',
      term: '2.5ヶ月',
      overview:
        '多くの企業では、新規事業の検討ならびにビジネス機会の創出にあたって、社内でワーキンググループを蘇生して社内で会議を重ねているものの、思った成果がでないと思われているケースは少なくないと思います。この原因の多くは、会議をすることが目的化してしまい、創造的な対話ができていないことにあります。このプロジェクトでは、それまでの自社が持っている強みからビジネス機会の創出を検討するのではなく、未来の姿を描き直してから、それを自社に当てはめることによって自社では何ができるのだろうかと、発想のフレームを逆にしたアイデア検証を行いました。未来をイメージするにあたって、検討テーマに対する未来新聞をワークしてもらい、各社がそれに対してどういったことが可能かを、会社横断のチームでアイディエーションとワールドカフェによるアイデア交換を実施しました。最終的には、これらのアイディエーションから出てきた幾つかのテーマをベースに、社内の新規事業としての素案作成につながりました。',
    },
  ]

  return (
    <>
      <ServiceMainTitle serviceMainTitle={serviceMainTitle} paths={paths} />
      <About list={aboutList} />
      <Assignment list={assignmentList} rowCount={2} />
      <div className={styles.colored}>
        <Whyi3 list={reasonList} />
      </div>
      <Process list={processList} isVisibleAnnotation />
      <CaseStudyLarge caseStudyObject={caseStudyList} />
      <div className={styles.linklist}>
        <MailmagazineLink />
      </div>
    </>
  )
}

export default Hip
